import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Radio } from '@thoughtspot/radiant-react/widgets/radio';
import React from 'react';
import { ExportTMLOptions } from './ExportUserTMLoptions';
export const ExportTML = ({ onModalDismiss, onRadioButtonChange, getEdoc, isGetEdocLoading, shouldExportDependencies, isExportDependenciesModalOpen, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { isOpen: isExportDependenciesModalOpen, size: ModalSize.SMALL, title: t('exportDependents.title'), confirmButton: {
            text: t('EXPORT'),
            onConfirm: getEdoc,
            isLoading: isGetEdocLoading,
        }, dismissButton: {
            text: t('CANCEL'),
        }, onDismiss: () => {
            onModalDismiss();
        }, doNotDismissOnOutsideClickOrEsc: true },
        React.createElement(Vertical, null,
            React.createElement(Radio.Group, { id: "export-tml-options", selectedValue: shouldExportDependencies
                    ? ExportTMLOptions.OBJECT_WITH_DEPENDENCIES
                    : ExportTMLOptions.OBJECT_ONLY, onChange: onRadioButtonChange, orientation: "list" },
                React.createElement(Radio, { id: ExportTMLOptions.OBJECT_ONLY, label: t('users.export.only.object'), value: ExportTMLOptions.OBJECT_ONLY, "data-testid": "object-only" }),
                React.createElement(Radio, { id: ExportTMLOptions.OBJECT_WITH_DEPENDENCIES, label: t('users.export.dependencies.label'), value: ExportTMLOptions.OBJECT_WITH_DEPENDENCIES, "data-testid": "object-with-dependents", "data-tooltip-content": t('users.export.dependencies.tooltip'), "data-tooltip-align": "left", "data-tooltip-position": "bottom" })),
            React.createElement("br", null))));
};
//# sourceMappingURL=usersExportModal.js.map